import { Check, Lock, Sparkles } from "lucide-react";
import { PERMIT_ADDON_PRICING } from "../data/staticData";

// --- Style resolvers extracted from JSX to avoid nested ternaries ---

function cardClasses({ isDisabled, isSelected }) {
  if (isDisabled) {
    return "border-white/10 bg-[#0A0A0A]/60 opacity-50 cursor-not-allowed";
  }
  if (isSelected) {
    return "border-[#7CFF00] bg-[#7CFF00]/[0.08] shadow-[0_0_28px_rgba(124,255,0,0.35)]";
  }
  return "border-white/15 bg-[#0A0A0A] hover:border-[#7CFF00]/60 hover:bg-[#0F0F0F]";
}

function badgeClasses({ isDisabled, isSelected }) {
  if (isDisabled) return "border-white/10 text-zinc-500";
  if (isSelected) return "border-[#7CFF00] text-[#7CFF00] bg-[#7CFF00]/10";
  return "border-[#7CFF00]/40 text-[#7CFF00] bg-[#7CFF00]/5";
}

function priceTextClasses({ isDisabled, isSelected }) {
  if (isDisabled) return "text-zinc-600";
  if (isSelected) return "text-[#7CFF00]";
  return "text-zinc-400";
}

function priceLabel({ isDisabled }) {
  return isDisabled ? "Unavailable" : `+ $${PERMIT_ADDON_PRICING.perState}`;
}

export default function AddOnCard({ addon, isSelected, onToggle }) {
  const isDisabled = !addon.available;
  const codeLower = addon.code.toLowerCase();

  const handleClick = () => {
    if (addon.available) onToggle(addon.code);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isDisabled}
      data-testid={`addon-${codeLower}`}
      aria-pressed={isSelected}
      aria-disabled={isDisabled}
      className={`relative text-left p-4 border transition-all duration-300 group ${cardClasses(
        { isDisabled, isSelected }
      )}`}
    >
      {isDisabled && (
        <span
          data-testid={`addon-${codeLower}-coming-soon`}
          className="absolute top-2 right-2 px-2 py-0.5 bg-zinc-800 text-zinc-400 text-[9px] font-mono-tactical tracking-[0.2em] uppercase border border-white/10"
        >
          Coming Soon
        </span>
      )}

      {isSelected && (
        <span
          data-testid={`addon-${codeLower}-selected`}
          className="absolute top-2 right-2 w-6 h-6 bg-[#7CFF00] text-black flex items-center justify-center"
        >
          <Check className="w-4 h-4" />
        </span>
      )}

      <div className="flex items-center gap-2 mb-2">
        <span
          className={`font-mono-tactical text-[10px] tracking-widest uppercase px-2 py-1 border ${badgeClasses(
            { isDisabled, isSelected }
          )}`}
        >
          {addon.code}
        </span>
        {isDisabled && <Lock className="w-3 h-3 text-zinc-500" />}
      </div>

      <div
        className={`font-tactical uppercase tracking-wider text-sm md:text-base ${
          isDisabled ? "text-zinc-500" : "text-white"
        }`}
      >
        {addon.name}
      </div>

      <div
        className={`mt-2 font-mono-tactical text-xs ${priceTextClasses({
          isDisabled,
          isSelected,
        })}`}
      >
        {priceLabel({ isDisabled })}
      </div>

      {isSelected && (
        <div className="mt-2 text-[10px] font-tactical uppercase tracking-widest text-[#7CFF00] flex items-center gap-1">
          <Sparkles className="w-3 h-3" /> Selected
        </div>
      )}
    </button>
  );
}
